import React from 'react';
import Presentacion from './Presentacion';
import About from './About';
import Works from './Works';
import Contact from './Contact';

const Main = () => {
    return ( 
        <main>
            <Presentacion />
            <About />
            <Works />
            <Contact />
        </main>
     );
}

export default Main;